export interface Department {
  id: string;
  name: string;
  shortName: string;
  description: string;
  icon: string;
  color: string;
  concerns: string[];
}

export const departments: Department[] = [
  {
    id: "cardiology",
    name: "Cardiology",
    shortName: "Cardiology",
    description:
      "Our Cardiology team specialises in the diagnosis and treatment of heart and cardiovascular conditions, including coronary artery disease, heart failure, arrhythmias, and hypertension.",
    icon: "❤️",
    color: "#922B21",
    concerns: ["heart-chest"],
  },
  {
    id: "neuro-spine",
    name: "Neuro & Spine Surgery",
    shortName: "Neurology",
    description:
      "Our Neuro & Spine Surgery department addresses conditions of the brain, spinal cord, and peripheral nervous system, including headaches, seizures, stroke, and spinal disorders.",
    icon: "🧠",
    color: "#6B21D4",
    concerns: ["brain-nervous"],
  },
  {
    id: "orthopaedics",
    name: "Orthopaedics",
    shortName: "Orthopaedics",
    description:
      "Our Orthopaedics team manages conditions affecting bones, joints, muscles, and the musculoskeletal system, including fractures, arthritis, and joint replacement.",
    icon: "🦴",
    color: "#1E8449",
    concerns: ["bones-joints"],
  },
  {
    id: "gynaecology",
    name: "Gynaecology & Obstetrics",
    shortName: "Gynaecology",
    description:
      "Our Gynaecology & Obstetrics team provides comprehensive care for women's health, including pregnancy, delivery, menstrual disorders, and reproductive health.",
    icon: "👩",
    color: "#7D3C98",
    concerns: ["womens-health"],
  },
  {
    id: "paediatrics",
    name: "Paediatrics",
    shortName: "Paediatrics",
    description:
      "Our Paediatrics team provides specialised medical care for infants, children, and adolescents, including newborn care, vaccinations, and developmental assessment.",
    icon: "👶",
    color: "#1A5276",
    concerns: ["child-health"],
  },
  {
    id: "general-medicine",
    name: "General Medicine",
    shortName: "General Medicine",
    description:
      "Our General Medicine team manages a wide range of adult medical conditions, including fever, infections, diabetes, hypertension, and general health concerns.",
    icon: "🩺",
    color: "#2471A3",
    concerns: ["fever-infection", "diabetes", "other"],
  },
  {
    id: "pulmonology",
    name: "Pulmonology",
    shortName: "Pulmonology",
    description:
      "Our Pulmonology team specialises in respiratory conditions including asthma, COPD, pneumonia, and breathing difficulties.",
    icon: "🫁",
    color: "#1B4F72",
    concerns: ["breathing"],
  },
  {
    id: "oncology",
    name: "Oncology",
    shortName: "Oncology",
    description:
      "Our Oncology team provides evaluation and guidance for cancer concerns, working with a multidisciplinary team for comprehensive cancer care.",
    icon: "🎗",
    color: "#C9A84C",
    concerns: ["cancer"],
  },
  {
    id: "urology",
    name: "Urology",
    shortName: "Urology",
    description:
      "Our Urology team manages conditions of the urinary tract and male reproductive system, including kidney stones, prostate disorders, and urological cancers.",
    icon: "🔵",
    color: "#1A5276",
    concerns: [],
  },
  {
    id: "nephrology",
    name: "Nephrology",
    shortName: "Nephrology",
    description:
      "Our Nephrology team specialises in kidney health, including chronic kidney disease, dialysis management, and transplant immunology.",
    icon: "🫘",
    color: "#0B5345",
    concerns: [],
  },
  {
    id: "plastic-surgery",
    name: "Plastic & Cosmetic Surgery",
    shortName: "Plastic Surgery",
    description:
      "Our Plastic & Cosmetic Surgery department offers reconstructive and cosmetic procedures, including micro-vascular surgery.",
    icon: "✨",
    color: "#6B21D4",
    concerns: [],
  },
  {
    id: "ophthalmology",
    name: "Ophthalmology",
    shortName: "Ophthalmology",
    description:
      "Our Ophthalmology team provides comprehensive eye care, including cataract surgery, retinal treatments, and refractive procedures.",
    icon: "👁",
    color: "#0E6655",
    concerns: [],
  },
  {
    id: "general-surgery",
    name: "General Surgery",
    shortName: "General Surgery",
    description:
      "Our General Surgery team performs a range of surgical procedures including laparoscopic and minimal access surgeries.",
    icon: "🏥",
    color: "#117A65",
    concerns: [],
  },
  {
    id: "nutrition",
    name: "Clinical Nutrition & Dietetics",
    shortName: "Nutrition",
    description:
      "Our Nutrition team provides evidence-based dietary guidance for managing chronic conditions, weight, and overall health.",
    icon: "🥗",
    color: "#1E8449",
    concerns: [],
  },
];

export const getDepartmentById = (id: string): Department | undefined =>
  departments.find((d) => d.id === id);